export let vuetifyTheme = {
  primary:        '#005eb8',
  secondary:      '#80BD00',
  accent:         '#257ed1',

  success:        '#80BD00',
  info:           '#578beb',
  error:          '#db1818',

  tp_blue:        '#005eb8',
  tp_blue_dark:   '#003587',
  tp_blue_light:  '#578beb',

  tp_green:       '#80BD00',
  tp_green_dark:  '#4c8c00',
  tp_green_light: '#b4f04a',

  tp_blue_grey:   '#5f7f9c',     /* blue-gray */

  tp_grey:        '#757575',     /* not from tp, it's Vuetify */
  tp_grey_dark:   '#2b2b2b',
  tp_grey_light:  '#afafaf',

  tp_blue_transparent: '#005eb84d',
  tp_blue_bgr:   '#b3dcffa1'
}